import { radius as radiusTokens } from './tokens.generated'

// ----------------------------------------------------------------------
// Radius has four roles and two ramps. Radius scales with density exactly the
// way type size does, and the tier decides which ramp applies — a 20px card
// radius at console density reads as bubbly, and a 14px hero image reads as
// unfinished. Mixing ramps inside one view is the error.
//
// The backoffice is tier 3, so it takes the console ramp. Exposed on the theme
// as `theme.radii` so a component never writes a number.
//
// The values are CSS lengths, not numbers, and that is deliberate: MUI's `sx`
// multiplies a *numeric* `borderRadius` by `theme.shape.borderRadius`, so
// `borderRadius: 14` would render 112px. A string passes through untouched, so
// the same constant is correct in `sx`, in a `styled()` block and in a theme
// override.
// ----------------------------------------------------------------------

const px = (value: number) => `${value}px`

const radii = {
  /** Code tags, plates, VINs, small badges. The same on every surface. */
  inline: px(radiusTokens.console.inline),
  /** Inputs, buttons, menu items, icon buttons. */
  control: px(radiusTokens.console.control),
  /** Cards, panels, sheets, media frames, map callouts. */
  surface: px(radiusTokens.console.surface),
  /** Chips, toggles, avatars, filter chips. */
  pill: px(radiusTokens.console.pill),
} as const

export type Radii = typeof radii

declare module '@mui/material/styles' {
  interface Theme {
    radii: Radii
  }
  interface ThemeOptions {
    radii?: Radii
  }
}

export default radii
